import {
  SET_STEP,
  SET_TOKEN,
  SET_GOOGLE_TOKEN,
  SET_APPLE_TOKEN,
  SET_REFERRAL_CODE,
} from './types'

function setStep(step) {
  return {
    type: SET_STEP,
    payload: {
      step,
    },
  }
}

function setToken(token) {
  return {
    type: SET_TOKEN,
    payload: {
      token,
    },
  }
}

function setGoogleToken(googleToken) {
  return {
    type: SET_GOOGLE_TOKEN,
    payload: {
      googleToken,
    },
  }
}

function setAppleToken(appleToken) {
  return {
    type: SET_APPLE_TOKEN,
    payload: {
      appleToken,
    },
  }
}

function setReferralCode(referralCode) {
  return {
    type: SET_REFERRAL_CODE,
    payload: {
      referralCode,
    },
  }
}

export { setStep, setToken, setGoogleToken, setAppleToken, setReferralCode }
